/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  function isMonsterActive() {
    return !!document.querySelector('script[src*="/cart_renderer"]');
  }

  function ajaxAddToCart(form) {
    var formData = new FormData(form);
    var btn = form.querySelector('[type="submit"], [data-add-to-cart]');
    if (btn) {
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('is-loading');
      btn.classList.remove('is-added');
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
      credentials: 'same-origin'
    })
      .then(function(res) { return res.json().then(function(body) { return { ok: res.ok, body: body }; }); })
      .then(function(result) {
        if (!result.ok) {
          document.dispatchEvent(new CustomEvent('theme:product:add-error', { detail: { error: result.body } }));
          throw result.body;
        }
        document.dispatchEvent(new CustomEvent('theme:product:add', { detail: { response: result.body } }));
        document.dispatchEvent(new CustomEvent('theme:product:added', { detail: { response: result.body } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (typeof window.monster_refresh === 'function') {
          window.monster_refresh();
        }
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setTimeout(function() { btn.classList.remove('is-added'); }, 1500);
        }
      })
      .catch(function() {
        if (btn) btn.classList.remove('is-loading');
      })
      .finally(function() { if (btn) btn.removeAttribute('disabled'); });
  }

  function bindForm(form) {
    if (form.dataset.monsterCartBound === '1') return;
    form.dataset.monsterCartBound = '1';

    form.addEventListener('submit', function(e) {
      if (!isMonsterActive()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      ajaxAddToCart(form);
    }, true);

    var btn = form.querySelector('[type="submit"], [data-add-to-cart]');
    if (btn) {
      btn.addEventListener('click', function(e) {
        if (!isMonsterActive()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        ajaxAddToCart(form);
      }, true);
    }
  }

  function bindAll() {
    document.querySelectorAll('form[action="/cart/add"], form[action^="/cart/add"]').forEach(bindForm);
  }

  document.addEventListener('DOMContentLoaded', bindAll);

  var observer = new MutationObserver(bindAll);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
